import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { DealService } from '../../services/deal.service';
import { getCustomFieldSchemas, initializeCustomFields, makeTableCustomFields } from '../../utils/CustomFieldEntities/custom-field-utils';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export const comments = writable([]);
export const customFieldsSchemas = writable([]);
export const tableCustomFields = writable([]);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await loadCustomFieldSchemas();
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    stats.set(null);
    await loadCustomFieldSchemas();
    if (oid == 0) {
        let tmpRecord = { oid: 0 };
        tmpRecord.customFields = initializeCustomFields(get(customFieldsSchemas));
        record.set(tmpRecord);
    }
    else {
        let _resp = await DealService.fetchDeal(oid).toPromise();
        record.set(_resp.payload);
        await loadStats(oid);
        await loadComments(oid);
    }
}
async function loadCustomFieldSchemas() {
    let schemas = await getCustomFieldSchemas("DEALXXXXXX");
    customFieldsSchemas.set(schemas);
    let tcf = await makeTableCustomFields(schemas, 'deal');
    tableCustomFields.set(tcf);
}
async function loadStats(customerOid) {
    // let _resp = await DealService.fetchDealStats(customerOid).toPromise();
    // stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await DealService.getDeals(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    navigate(`/deal/0`);
}
export function onEdit(item) {
    navigate(`/deal/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return DealService.saveDeal(_record).toPromise();
}
export async function onDelete(item) {
    await DealService.deleteDeal(item.oid).toPromise();
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
// ----------------------------------------------------------------------
// Comments
// ----------------------------------------------------------------------
export async function loadComments(oid) {
    let _resp = await DealService.getDealComments(oid).toPromise();
    comments.set(_resp.payload);
}
export async function addComment(event) {
    let comment = event.detail;
    await DealService.saveDealComment(comment).toPromise();
    loadComments(comment.entityId);
}
export async function delComment(event) {
    let comment = event.detail;
    await DealService.deleteDealComment(comment.oid).toPromise();
    loadComments(comment.entityId);
}
